import matchIcon from "src/assets/icons/matchIcon.svg";
import chipIcon from "src/assets/icons/chip.svg";

import { useStyles } from "./styles";

interface IRoundsProps {
    rounds: number;
    isMobile?: boolean;
    isMatch: boolean;
}

export const Rounds = ({ rounds, isMobile, isMatch }: IRoundsProps) => {
    const classes = useStyles();
    return (
        <div className={classes.wrapperRounds}>
            {!isMatch ? (
                <img src={chipIcon} className={classes.chipIcon} />
            ) : (
                <>
                    <img src={matchIcon} className={classes.flagIcon} />
                    <span className={classes.roundsLabel}>{rounds}</span>
                </>
            )}
        </div>
    );
};
